// extracted by mini-css-extract-plugin
export default {"superInput":"SuperInputText_superInput__2E+Vh","errorInput":"SuperInputText_errorInput__wnv1F","error":"SuperInputText_error__NzTSR"};